module.exports = __webpack_public_path__ + "media/video2.cdf59f8b.mp4";